<div class="priority-container">
  <div class="priority-block">
    <h3>Prioridad por competición</h3>
    <p>Selecciona las competiciones cuyos vídeos deben procesarse con preferencia.</p>

    @if (isLoadingCompetitions) {
      <p>Cargando competiciones...</p>
    } @else {
      <div class="competition-list">
        @for (competition of competitions; track competition.id) {
          <label class="competition-item">
            <input
              type="checkbox"
              [checked]="selectedCompetitionIds.has(competition.id)"
              (change)="toggleCompetitionSelection(competition.id, $any($event.target).checked)"
            />
            <span>{{ competition.name }}</span>
          </label>
        }
      </div>
      <div class="actions">
        <button (click)="saveCompetitionPriorities()" [disabled]="isSavingCompetitions">
          Guardar prioridad por competición
        </button>
      </div>
    }
  </div>

  <div class="priority-block">
    <h3>Prioridad manual por vídeo</h3>
    <p>Busca por nombre, selecciona uno o varios vídeos y aplica o retira prioridad manual.</p>

    <div class="search-row">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Buscar vídeo por nombre"
        (keyup.enter)="searchVideos()"
      />
      <button (click)="searchVideos()" [disabled]="isSearchingVideos">Buscar</button>
    </div>

    <div class="video-toolbar">
      <span class="video-counter">Resultados: {{ videos.length }}</span>
      <span class="video-counter">Seleccionados: {{ selectedVideosCount }}</span>
      @if (isSearchingVideos) {
        <span class="video-loading">Actualizando lista...</span>
      }
    </div>

    <div class="video-list" [class.searching]="isSearchingVideos">
      @if (videos.length === 0 && hasSearchedVideos) {
        <div class="video-empty">No se encontraron vídeos para esa búsqueda.</div>
      }

      @for (video of videos; track video.video_id) {
        <label class="video-item">
          <input
            type="checkbox"
            [checked]="isVideoSelected(video.video_id)"
            (change)="toggleVideoSelection(video.video_id, $any($event.target).checked)"
          />
          <div class="video-main">
            <span class="video-title">{{ video.title }}</span>
            <span class="video-meta">
              {{ video.competition_name || 'Sin competición' }} · {{ video.status }}
            </span>
            <span class="video-id">{{ video.video_id }}</span>
          </div>
          <div class="video-badges">
            @if (video.is_competition_priority) {
              <span class="badge badge-competition">Comp</span>
            }
            @if (video.is_manual_priority) {
              <span class="badge badge-manual">Manual</span>
            }
            <span class="badge badge-level">P{{ video.effective_priority }}</span>
          </div>
        </label>
      }
    </div>

    <div class="actions">
      <button (click)="applyManualPriority(true)" [disabled]="!hasSelectedVideos || isUpdatingVideos">
        Aplicar prioridad manual
      </button>
      <button
        class="secondary"
        (click)="applyManualPriority(false)"
        [disabled]="!hasSelectedVideos || isUpdatingVideos"
      >
        Quitar prioridad manual
      </button>
    </div>
  </div>

  @if (feedbackMessage) {
    <p class="feedback">{{ feedbackMessage }}</p>
  }
</div>
